import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { RouterState, StoreRouterConnectingModule } from '@ngrx/router-store';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { environment } from 'src/environments/environment';
import { AuthEffects } from './auth/auth.effects';
import { ProjectsEffects } from './projects/projects.effects';
import { metaReducers, reducers } from './reducers';
import { ResultsEffects } from './results/results.effects';
import { routerFeatureKey } from './routing/routing.reducer';

@NgModule({
  imports: [
    StoreModule.forRoot(reducers, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        // strictActionImmutability: true,
      },
    }),
    !environment.production
      ? StoreDevtoolsModule.instrument({
          maxAge: 25, // Retains last 25 states
          logOnly: environment.production, // Restrict extension to log-only mode
        })
      : [],
    EffectsModule.forRoot([ResultsEffects, AuthEffects, ProjectsEffects]),
    // StoreModule.forFeature(routerFeatureKey, routerReducer),
    StoreRouterConnectingModule.forRoot({
      stateKey: routerFeatureKey,
      routerState: RouterState.Minimal,
    }),
  ],
})
export class CoreStoreModule {}
